// API Configuration
export const API_URL = process.env.NODE_ENV === 'production'
  ? 'https://glowspirit-server.onrender.com'
  : 'http://localhost:5000';

// Other configuration constants can be added here
export const APP_NAME = 'Glowspirit';
export const APP_VERSION = '1.0.0';

// Feature flags
export const REGISTER_DISABLED = true; // Set this to false to enable registration 